export default {
	methods: {
		trackGTM: function (page, title) {
			const pageName = (page !== undefined) ? page : '/' + this.$route.name
			const pageTitle = (title !== undefined) ? title : this.$route.meta.gtm
			if (this.$gtm && this.$gtm.enabled()) {
				return this.$gtm.trackView(
					pageTitle,
					pageName)
			}
		}
	}
}
